<template>
    <div class="site__body">
        <div class="block-space block-space--layout--spaceship-ledge-height"></div>
        <div class="block faq">
    
            <div class="container container--max--xl">
              <div class="flexbox-page-info-container">
                  <div class="flex-item-page-info-breadcrumbs">
                    <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                        <ol class="breadcrumb__list">
                            <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                            <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                            </li>
                            <li class="breadcrumb__item breadcrumb__item--parent">
                                <router-link to="/search-results" class="breadcrumb__item-link">Search Results</router-link>
                            </li>					                                						                               
                            <li class="breadcrumb__item breadcrumb__item--parent">
                                <router-link to="" class="breadcrumb__item-link">Buyer's Guide</router-link>
                            </li>					                                						                               
                            <li class="breadcrumb__title-safe-area" role="presentation"></li>
                        </ol>
                      </nav>
                  </div>
                
                  <div class="flex-item-page-info-title">
                    <h1 class="block-header__breadcrumb-slim">Buyer's Guide</h1>
                  </div>
              </div>

              <div class="document__content card">
                  
                <div class="document__content">

                    <div class="flex-container--breadcrumbs-selected-vehicle-buyers-guide">
                      <div class="flex-container--breadcrumbs-selected-vehicle">
                          <div class="flex-container--select-vehicle-column">
                              <div class="vehicles-list__item-name">{{selected_year}} {{selected_make.desc}} {{selected_model.desc}}</div>
                              <div class="vehicles-list__item-details-category-display">{{selected_engine.desc}}</div>
                          </div>					
                          <div class="flex-container--select-vehicle-column">
                            <div class="product__tags tags tags--sm">
                              <div class="tags__list tags__list-select-vehicle">                         
                                    <button class="mobile-search__vehicle-picker change-vehicle__button" type="button">
                                      <span class="search__button-icon">
                                        <svg width="20" height="20">
                                              <path d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1
                                              c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2
                                              C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9
                                              c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0
                                              c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0
                                              C15.5,10.2,14,11.3,14,12z" />
                                          </svg>
                                      </span>
                                    <span class="search__button-title">Change Vehicle</span>
                                  </button>                                                      
                                </div>
                            </div>
                          </div>
                      </div>
                    </div>

                    <div class="buyers-row">
                        <b>Buyer's Guide</b>
                        <div class="">
                          <label class="">Description:</label> <b><span>{{ item_desc }}</span></b>
                        </div>
                        <div class="">
                          <label class="">Manufacturer:</label> <span>{{ manufacturer_desc }}</span>
                        </div>
                        <div class="">
                          <label class="">Part Number:</label> <b><span>{{ part_number }}</span></b>
                        </div>
                        <div class="" v-if="oe_number != ''">
                          <label class="">OE Number:</label> <span>{{ oe_number }}</span>
                        </div>
                        
                    </div>

                    <!-- <img class="buyers-prod-img" v-if="show_img == true" :src="resource_img" alt=""  /> -->

                </div>
                <buyers-guide-tree class="mt-2" ref="guideTree" :item_num="item_code" :mfg_code="mfg_code"></buyers-guide-tree>

                <div class="product-card__information" v-if="notes.length > 0">
                    <div>
                      <h5>NOTES: </h5>
                    </div>

                    <ul class="">
                        <li v-for="(desc, i) in notes" :key="i" v-html="desc.ETXITUSE"></li>
                    </ul>			
                </div>
              </div>
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>

</template>

<script>
import BuyersGuideTree from './BuyersGuideTree';
import VehicleSearch from '../../../mixins/vehicle_search.js';
import Product from '../../../mixins/product';
import { mapGetters } from 'vuex';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    name: 'BuyersGuide',
    mixins: [VehicleSearch, Product],
    components: {
        BuyersGuideTree
    },
    data() {
      return {
        manufacturer_desc: '',
        item_desc: '',
        item_longdesc: '',
        resource_img: '',
        show_img : true,
        notes: [],

        mfg_code: this.$route.params.QMFRCD,
        item_code: this.$route.params.QITEMC,

        // manufacturer : null,
        // part_number : null,
      }
    },
    computed: {
      ...mapGetters([
          'storeCatalog', 
      ]),

      manufacturer(){
        return this.$route.params.QMFRCD;
      },

      part_number(){
        return this.$route.params.QITEMC;
      },

      oe_number(){
        return this.$route.params.QTYPEC;
      }
    },

    methods: {
      ProductInfo() {

        this.mx_product_details(this.manufacturer, this.part_number).then(product => {
          console.log(product);
        });
        
      },

      getImage() {
        const mfgs = this.$store.getters.mfgs_imgs;
        // WHI result item
        if (this.storeCatalog === 'WHI'){
          this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
          this.show_img = false;
        }
        
        // PARTSLINK ITEM
        if (this.storeCatalog === 'PARTSLINK'){
            const clApi = new CloudinaryApi;
            clApi.item_sku = this.item_code
            clApi.manufacturer_code = this.mfg_code;
            
            clApi.vlImageByMeta(GCONST.CL_METARTYPE_PARTSLINK, GCONST.PL_Product_BGuide).then(imgURL => {
                if(imgURL){
                    this.resource_img = imgURL;
                    // console.log(imgURL);
                }else{
                  const mfg = mfgs.find(m => (m.CL_MFGCODE == this.manufacturer));
                  if(mfg){
                      this.resource_img = mfg.CL_RESURL;
                  }else{
                      this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
                  }
                }
            });
        }
        
      },

      searchPLItems() {
            this.parts = [];
            this.isloading = true;
            let params;
            const pl_itemsearch_uri = this.$store.getters['api/pl_itemsearch_uri'];
            const catpn = this.$store.getters['storeConfigID'];

            params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN": { "value": catpn },
                        "SRCITM": { "value": this.item_code },
                    }
                }
            };

            axiosvl.post(pl_itemsearch_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                if (fields.RESULTCOD.value === 'OK') {
                  const lists = response.data.webroutine.lists;
                  const PARTS = lists.PARTS.entries;
                  const ETXLIST = lists.ETXLIST.entries;
                  this.notes = ETXLIST.filter(i => i.ETXITM == this.part_number);
                  
                  const pl_item = PARTS.find(pl => pl.QITEMNUM == this.part_number && pl.QMFR == this.manufacturer);
                  this.manufacturer_desc = pl_item.QMFDSC;
                  this.item_desc = pl_item.QITDSC;
                }

                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
      },


      searchPartsLink() {
            this.parts = [];
            this.isloading = true;
            let params;
            const vehicle_parts_uri = this.$store.getters['api/vehicle_partsM_uri'];
            const catpn = this.$store.getters['storeConfigID'];

            params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN": { "value": catpn },
                        "QYEAR": { "value": this.$store.getters['vehicle/selectedyear'] },
                        "QMKDSC": { "value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                        "QMODSC": { "value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                    },
                    "lists": {
                        "TYPESI": {
                            "header": [
                                {"name": "QTYPE"},
                                {"name": "QGROUP"}
                            ],
                            "entries": this.$store.getters['vehicle/selectedcategories']
                        }
                    }     
                }
            };

            axiosvl.post(vehicle_parts_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const ETXLIST = lists.ETXLIST.entries;
                const PARTS = lists.PARTS.entries;

                this.parts_desc = ETXLIST;
                if (fields.RESULTCOD.value === 'OK') {

                  const search_item = PARTS.find(p => p.QITEMNUM == this.part_number);
                  
                  let desc = '';
                  let parentItem = null;
                  if (search_item.CLTYPE == 'SUBSTITUTE'){
                    parentItem = PARTS.find(par => par.QITEMSZ == search_item.QITEMNUM.slice(0, -1));
                    // console.log(parentItem);
                    desc = this.parts_desc.filter(i => i.ETXITM == parentItem.QITEMNUM);
                    this.mfg_code = parentItem.QMFR;
                    this.item_code = parentItem.QITEMNUM;
                    this.manufacturer_desc = parentItem.QMFDSC;
                    this.item_desc = parentItem.QITDSC;

                    this.$refs.guideTree.getTreeData(this.item_code);
                  }else{
                    this.searchPLItems();
                    desc = this.parts_desc.filter(i => i.ETXITM == search_item.QITEMNUM);
                  }
                  // this.getImage();

                  this.item_longdesc = desc;
                }

                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
      },
    },
    created() {
      this.ProductInfo();

      if (this.storeCatalog === 'PARTSLINK'){
        this.searchPartsLink();
      }else{
        this.manufacturer_desc = this.$route.params.QMFRCD;
      }

      this.$ga.page({
          page: this.$route.fullPath,
          title: this.$route.name,
      });
    }
}
</script>

<style scoped>
  .buyers-prod-img{
    position: absolute;
    top: 10px;
    right: 20px;
    width: 230px;
  }
  .buyers-row {
    margin-top: 30px;
  }

  .buyers-row label{
    width: 30%;
  }
</style>